import * as R from "ramda";

export const dataAttrsForField = (field, listItem = false) => {
  let uiType;
  if (listItem) {
    uiType = R.path(["ui", "form_input", "item_ui", "type"], field);
  } else {
    uiType = R.path(["ui", "form_input", "type"], field);
  }
  const dataAttrs = {
    "data-field-id": field.id,
    "data-field-key": field.key,
    "data-field-name": field.field_label,
    "data-field-type": field.field_type,
    "data-field-ui-type": uiType,
  };

  if (!listItem && uiType === "list") {
    dataAttrs["data-field-list-item-ui-type"] = R.path(
      ["ui", "form_input", "item_ui", "type"],
      field,
    );
  }
  return dataAttrs;
};
